import { TagAttributes } from "@/(admin)/modules/ui-builder/config/types"
import { message } from "antd"
import { AxiosRequestConfig } from "axios"
import { HttpClient } from "../../../../app/api/HttpClient"
import { FilterSearchParams } from "../../../../lib/external-components"

export const API_PREFIX_PATH = "/api/tags"
export const fetchTags = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      pageSize: "20",
    },
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_PATH}`, { params })
    return response
  } catch (error) {
    message.error("Không thể lấy danh mục. Vui lòng thử lại.")
  }
}

export const updateTag = async (id: string, updatedData: TagAttributes) => {
  return await HttpClient.put(`${API_PREFIX_PATH}/${id}`, { data: updatedData })
}
export const createTag = async (data: TagAttributes) => {
  return await HttpClient.post(`${API_PREFIX_PATH}`, { data })
}

export const deleteTag = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_PATH}/${id}`)
}

export const getTagById = async (id: number) => {
  return await HttpClient.get(`${API_PREFIX_PATH}/${id}`)
}

export const checkSlug = async (slug: string) => {
  const params: AxiosRequestConfig["params"] = {
    filters: {
      slug: { $eq: slug },
    },
    publicationState: "preview",
  }
  return await HttpClient.get(`${API_PREFIX_PATH}`, { params })
}
